import { A } from '@adornis/base/env-info.js';

import albertSansBold from './AlbertSans-Bold.ttf';
import albertSansLight from './AlbertSans-Light.ttf';
import albertSansRegular from './AlbertSans-Regular.ttf';
import albertSansThin from './AlbertSans-Thin.ttf';

import './fonts.js';

const style = document.createElement('style');
style.innerHTML = `
@font-face {
  font-family: "Albert Sans";
  src: url('${A.absoluteUrl(albertSansRegular)}');
  font-weight: normal;
}
@font-face {
  font-family: "Albert Sans";
  src: url('${A.absoluteUrl(albertSansLight)}');
  font-weight: light;
}
@font-face {
  font-family: "Albert Sans";
  src: url('${A.absoluteUrl(albertSansThin)}');
  font-weight: 100;
}
@font-face {
  font-family: "Albert Sans";
  src: url('${A.absoluteUrl(albertSansBold)}');
  font-weight: bold;
}
`;

document.head.appendChild(style);
